import { PublicClientApplication } from '@azure/msal-browser';

const tenantName = import.meta.env.VITE_ENTRA_TENANT_NAME;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

export const apiScope = `api://${clientId}/api.access`;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://${tenantName}.ciamlogin.com/${tenantId}`,
    knownAuthorities: [`${tenantName}.ciamlogin.com`],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // localStorage (not sessionStorage) so the signed-in session is SHARED
    // across browser tabs — opening a Deskte section in a new tab (right-click →
    // "Open in new tab") no longer forces a fresh sign-in. The idle-timeout
    // guard in the tenant middleware still bounds how long a session stays live.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access', apiScope],
};

export const tokenRequest = {
  scopes: [apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
